import { PlacementResult, ReplacePlacementResult, ValidationResult } from '@inter-ikea-core/core';
import { BehaviorParameters } from '../../@types';
import { ErrorMessages, InteriorComponent } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from '../../shared/rules/hideMenuRules';

const replaceInteriorsByDragAndDrop = ({ coreApi, props }: BehaviorParameters) => {
  const productId =
    props.coreProductIds?.length > 0 ? props.coreProductIds[0] : props.coreProductId;

  const entityToReplace =
    coreApi.entities.findSelectedEntity() ||
    coreApi.entities.getEntityAtPosition(props.position, [InteriorComponent.id]);

  let placementResult: ReplacePlacementResult | PlacementResult | null;

  if (entityToReplace) {
    placementResult = coreApi.products.replace(
      entityToReplace.id,
      productId
    ) as ReplacePlacementResult;
  } else {
    placementResult = coreApi.products.add(productId, props.position) as PlacementResult;
  }

  const isPlacementValid = (result: ReplacePlacementResult | PlacementResult): boolean => {
    if ('replacedEntityResult' in result) {
      return result.replacedEntityResult.valid && result.childrenResult.every(child => child.valid);
    }
    return result.valid;
  };

  const getPlacementErrors = (
    result: ReplacePlacementResult | PlacementResult
  ): ValidationResult[] => {
    if ('replacedEntityResult' in result) {
      const childErrors = result.childrenResult.flatMap(child => child.errors);
      return [...result.replacedEntityResult.errors, ...childErrors];
    }
    return result.errors;
  };

  const isValid = placementResult ? isPlacementValid(placementResult) : false;
  const errors = placementResult ? getPlacementErrors(placementResult) : [];

  if (!isValid && errors.length > 0 && !hideNoFramesInSceneErrorMessage(coreApi)) {
    const hasCollissions = errors.some(e => (e as any).collisions?.length > 0);
    if (hasCollissions) {
      coreApi.emit.onPlacementAttempt(ErrorMessages.ItemWontFit);
    }
    coreApi.entities.disposeCollidingEntities(errors);
  }

  return placementResult;
};

export default replaceInteriorsByDragAndDrop;
